import type { ApiClient } from "@/lib/api";

/**
 * Remove many catalog entries by id in a single request. POSTed (not DELETE)
 * because the id list travels in the body and the HTTP client doesn't send a
 * body on DELETE.
 */
export const deleteCatalogEntries = async (options: {
  client: ApiClient;
  entryIds: string[];
}) => {
  const { client, entryIds } = options;
  const { data } = await client.post("/catalog/delete", {
    entry_ids: entryIds,
  });
  return data;
};
